// وضعیت سفارشات تاپین - straight from the codes table in the Tapin API docs
export const TAPIN_ORDER_STATUS: Record<number, string> = {
  [-100]: 'منتظر استعلام (API)',
  [-1]: 'ثبت شده در فروشگاه (تحت بررسی) (API)',
  0: 'ثبت شده در فروشگاه (تحت بررسی)',
  1: 'آماده به پرینت (معلق پستی)',
  2: 'آماده به ارسال',
  3: 'اشتباه در اعلام آماده به ارسال',
  4: 'عدم حضور فروشگاه',
  5: 'قبول شد',
  6: 'عدم قبول (غیر قابل توزیع در مبدا)',
  7: 'توزیع شد',
  8: 'باجه معطل',
  9: 'غیر قابل توزیع (در مقصد)',
  10: 'پیش برگشتی مرسوله',
  11: 'ثبت نهایی برگشتی',
  12: 'مرسوله خسارتی',
  13: 'وارده به استان توزیع',
  14: 'تحویل به نامه رسان',
  15: 'مراجعه اول',
  16: 'مراجعه دوم',
  17: 'توزیع در صندوق پستی',
  18: 'بی ترتیبی (کسری مرسوله)',
  50: 'در حال جمع آوری',
  70: 'تایید شده مدیر مالی',
  71: 'تسویه شده مدیر مالی',
  72: 'تسویه شده با پست',
  80: 'حذف شده',
  81: 'بلاتکلیف',
  82: 'مانده قبول',
  83: 'تایید برگشتی',
  100: 'منتظر استعلام',
  101: 'در حال تغییر وضعیت',
  102: 'عودت داده شده',
  103: 'پیش ثبت سفارش',
};

// نوع ثبت سفارش
export const TAPIN_REGISTER_TYPE = [
  { value: 0, label: 'ثبت سفارش بدون بارکد' },
  { value: 1, label: 'ثبت با بارکد (آماده به پرینت)' },
  { value: 2, label: 'ثبت با بارکد (آماده به ارسال)' },
];

// the statuses a shop actually drives a parcel through itself
export const TAPIN_CHANGEABLE_STATUS = [
  { value: 1, label: 'آماده به پرینت' },
  { value: 2, label: 'آماده به ارسال' },
  { value: 80, label: 'حذف' },
];

export const tapinStatusTitle = (status?: number): string =>
  status == null ? '—' : TAPIN_ORDER_STATUS[status] || `وضعیت ${status}`;
